<template>
  <div>
    <!-- header slot 必须始终存在：v-if 包 slot 会在主题晚于 Modal mount 切到 white 时导致 showHead 一直为 false -->
    <Modal v-model="modal" :title="broadTitle" width="30%" class-name="emergency-dialog-modal" @on-cancel="close">
        <div slot="header" class="ed-title">
          <svg-icon v-if="isWhiteTheme" iconClass="emergency" color="#ffffff"/>
          <span>{{broadTitle}}</span>
        </div>
        <p>{{content}}</p>
        <div slot="footer">
          <Button type="primary" @click="okFun">{{ok}}</Button>
          <Button v-if="this.emergencyBroad && this.emergencyBroad.id && this.emergencyBroad.bEnable === 1" type="primary" @click="cancelFun">{{cancel}}</Button>
        </div>
    </Modal>
    <BroadConfig @modalChange="broadConfigVisible" :show="showConfigBroad"></BroadConfig>
  </div>
</template>
<script>

import BroadConfig from "../../../../view/broadcast/broad-config.vue";
import {queryEmergencyBroad} from '@/api/broadcast.js'
import {mapActions} from "vuex";
export default {
  name: 'EmergencyPop',
  components: {BroadConfig},
  props: {
    showEmergencyPop: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      modal:false,
      broadTitle: '',
      showConfigBroad: false,
      ok:'',
      cancel:'',
      content:'',
      emergencyBroad:{},
    }
  },
  methods:{
    ...mapActions([
      'sendMsg',
    ]),
    close(){
      this.$emit('closeBroad')
    },
    okFun(){
      this.modal = false;
      this.showConfigBroad = true
    },
    cancelFun(){
      let msg = '\'id\':\'' + this.emergencyBroad.id + '\''
      let method = this.emergencyBroad.running ? 'broadcast_stop':'broadcast_start'
      this.sendMsg({method, msg})
      this.close();
    },
    async queryEmBroad() {
      await queryEmergencyBroad().then(res=>{
        this.emergencyBroad = {
          running:false
        }
        let response = res.data
        if (response.code == 200) {
          this.emergencyBroad = response.data
          if (this.emergencyBroad.status == 1 || this.emergencyBroad.status == 2) {
            this.emergencyBroad.running = true
          } else {
            this.emergencyBroad.running = false
          }
        }
      }).catch(err=>{
        this.emergencyBroad = {
          running:false
        }
      })
    },
    async playEbs() {
      await this.queryEmBroad()
      this.showConfirm()
    },
    showConfirm: function () {
      //判断显示具体的弹窗
      if (!this.emergencyBroad || !this.emergencyBroad.id || this.emergencyBroad.bEnable != 1) {
        this.broadTitle = this.$t('e_broad.set_emergency');
        this.content = !this.emergencyBroad.id ? this.$t('e_broad.no_emergency') : (this.$t('emergency') + ' : ' + this.emergencyBroad.name + this.$t('e_broad.disabled'));
        this.ok = this.$t('e_broad.config');
        return
      }
      this.broadTitle = (this.emergencyBroad.running ? this.$t('stop') : this.$t('play')) + this.$t('emergency');
      this.content = this.$t('emergency') + ' : ' + this.emergencyBroad.name;
      this.ok = this.$t('e_broad.config');
      this.cancel = this.emergencyBroad.running ? this.$t('stop') : this.$t('play')
    },
    broadConfigVisible(val) {
      if (!val) {
        this.showConfigBroad = val
        //重新拉广播
        this.modal = true;
        this.playEbs()
      }
    },
  },
  computed: {
    isWhiteTheme() {
      return this.$store.state.app.theme === 'white'
    }
  },
  watch:{
    showEmergencyPop:{
      immediate:true,
      handler(val){
        this.modal = this.showEmergencyPop
        if (val) {
          this.playEbs()
        }

      }
    }
  }
}
</script>
<style scoped>
#defaultOpen /deep/ .ivu-select-selection{
  height: auto !important;
}

</style>



// WEBPACK FOOTER //
// src/components/main/components/emergency-pop/emergency-pop.vue